import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { chatIsPendingSelector, sortedUserRoomIdsSelector } from 'selectors'

import Spinner from 'components/Spinner'
import RoomsComponent from 'components/chat/Rooms'
import MessagesComponent from 'components/chat/Messages'

const Rooms = styled(RoomsComponent)`
  width: 100%;
  background-color: white;
`

const Messages = styled(MessagesComponent)`
  background-color: white;
`

const ChatWrapper = ({ roomIds, isPending, history }) => {
  const split = history.location.pathname.split('/')
  const activeRoom = split.length >= 2 ? split[2] : undefined

  if (isPending) {
    return <Spinner />
  }
  if (activeRoom) {
    return <Messages small roomId={activeRoom} />
  }
  return (
    <Rooms
      roomIds={roomIds}
      selectRoom={room => history.push(`/chat/${room}`)}
    />
  )
}

const mapStateToProps = state => ({
  isPending: chatIsPendingSelector(state),
  roomIds: sortedUserRoomIdsSelector(state) || [],
})

export default connect(mapStateToProps)(ChatWrapper)



// WEBPACK FOOTER //
// ./src/pages/Chat/SmallChat.js